<template>

  <section class="contact" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-md-6 p-0 text-right">
          <div class="section-title">
            <h2>الحصول على اتصال</h2>
          </div>
          <form class="auth-form">
            <div class="form-group">
              <label for="exampleInputName1">Name</label>
              <i class="fa fa-user"></i>
              <input
                required=""
                name="login[username]"
                type="text"
                class="form-control"
                id="exampleInputName1"
                placeholder="اسم المستخدم"
              />
            </div>
            <div class="form-group">
              <label for="exampleInputEmail12">Email</label>
              <i class="fa fa-envelope-o"></i>
              <input
                required=""
                name="login[email]"
                type="email"
                class="form-control"
                id="exampleInputEmail12"
                placeholder="البريد الإلكتروني"
              />
            </div>
            <div class="form-group">
              <label>Your message</label>
              <i class="fa fa-commenting-o"></i>
              <textarea
                class="form-control"
                name="message"
                id="message"
                cols="30"
                rows="10"
                placeholder="رسالتك"
              ></textarea>
            </div>
            <div class="form-group mb-0">
              <button class="btn-theme" type="submit">ارسل رسالة</button>
            </div>
          </form>
        </div>
        <div class="col-md-6">
          <div class="section-title text-right">
            <h2>معلومات الاتصال</h2>
            <p>
              أبجد هوز ليلة سعيدة امات, كرس الحسومات المطور هل تفعل كرس تيم من
              قبل إنديدي دنت.
            </p>
          </div>

          <ul class="contact-box">
            <li>
              <div class="contact-circle">
                <i class="fa fa-map-marker" aria-hidden="true"></i>
              </div>
              <div class="contact-text">
                <h3>الموقع</h3>
                <p>123 شارع الأعمال ، هيوستن ، الولايات المتحدة الأمريكية</p>
              </div>
            </li>
            <li>
              <div class="contact-circle">
                <i class="fa fa-phone" aria-hidden="true"></i>
              </div>
              <div class="contact-text">
                <h3>اتصل بنا</h3>
                <p>123-456-7890 91+</p>
              </div>
            </li>
            <li>
              <div class="contact-circle">
                <i class="fa fa-envelope" aria-hidden="true"></i>
              </div>
              <div class="contact-text">
                <h3>راسلنا</h3>
                <p>support@gmail.com</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
 
</template>
<script>
export default {
  name: "Footer",
};
</script>
